import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import { Spinner } from "@/components/common/States";
import { api, errorMessage } from "@/lib/api";
import { REPORT_REASONS } from "@/lib/labels";

export function ReportDialog({ target, open, onOpenChange }) {
  const [reason, setReason] = useState("spam");
  const [note, setNote] = useState("");
  const [err, setErr] = useState("");
  const kirim = useMutation({
    mutationFn: async () => (await api.post("/school/feed/reports", {
      target_type: target.type, target_id: target.id, reason, note: note.trim() || null,
    })).data,
    onSuccess: () => {
      setNote(""); setErr(""); onOpenChange(false);
      toast.success("Laporan dikirim. Guru, wali kelas, kepala sekolah, dan Admin Sekolah akan meninjaunya.");
    },
    onError: (e) => setErr(errorMessage(e)),
  });
  const tutup = (o) => { if (!o) { setNote(""); setErr(""); } onOpenChange(o); };

  return (
    <Dialog open={open} onOpenChange={tutup}>
      <DialogContent data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle>Laporkan {target.type === "post" ? "postingan" : "komentar"}</DialogTitle>
          <DialogDescription>
            Laporan terlihat oleh guru, wali kelas, kepala sekolah, dan Admin Sekolah. Gunakan hanya untuk konten yang benar-benar melanggar.
          </DialogDescription>
        </DialogHeader>
        <RadioGroup value={reason} onValueChange={setReason} className="gap-2" data-testid="report-reasons">
          {Object.entries(REPORT_REASONS).map(([v, label]) => (
            <label key={v} className="flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-muted">
              <RadioGroupItem value={v} id={`alasan-${v}`} /> {label}
            </label>
          ))}
        </RadioGroup>
        <div className="space-y-2">
          <Label htmlFor="report-note">Penjelasan (opsional, maksimal 500 karakter)</Label>
          <Textarea id="report-note" value={note} maxLength={500} onChange={(e) => setNote(e.target.value)}
            placeholder="Jelaskan singkat mengapa konten ini bermasalah" data-testid="report-note" />
        </div>
        {err && <p className="text-sm text-[#E11D2E]" role="alert" data-testid="report-error">{err}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={() => tutup(false)} data-testid="report-cancel">Batal</Button>
          <Button variant="destructive" disabled={kirim.isPending} onClick={() => kirim.mutate()} data-testid="report-submit">
            {kirim.isPending && <Spinner />} Kirim laporan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
